var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCtvRokuStore(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7416_6287)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.1111 20H3.88889C1.74111 20 0 18.2589 0 16.1111V3.88889C0 1.74111 1.74111 0 3.88889 0H16.1111C18.2589 0 20 1.74111 20 3.88889V16.1111C20 18.2589 18.2589 20 16.1111 20Z",
    fill: "url(#paint0_linear_7416_6287)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.56074 9.17009C4.56074 8.70516 4.14108 8.33105 3.62709 8.33105H3.16444V10.0017H3.62709C4.14044 10.0017 4.56074 9.62703 4.56074 9.17009ZM6.66675 12.5H4.96757L3.61875 10.8333H3.16508V12.496H1.66675V7.5H3.8119C5.04906 7.5 6.05843 8.2488 6.05843 9.16952C6.05843 9.73155 5.6715 10.233 5.08243 10.5403L6.66675 12.5Z",
    fill: "#FDFCEF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.91281 9.32142C7.55499 9.32142 7.25002 9.81079 7.25002 10.4164C7.25002 11.0225 7.55441 11.5119 7.91281 11.5119C8.27935 11.5119 8.58315 11.022 8.58315 10.4164C8.58315 9.81079 8.27935 9.32142 7.91281 9.32142ZM9.99992 10.4164C9.99992 11.5732 9.06412 12.5 7.91281 12.5C6.76208 12.5 5.83325 11.5738 5.83325 10.4164C5.83325 9.26011 6.76266 8.33334 7.91281 8.33334C9.06412 8.33275 9.99992 9.26011 9.99992 10.4164Z",
    fill: "#FDFCEF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.9547 8.33869L11.3726 9.93869V8.33334H10V12.4131H11.3726V10.7583L13.0241 12.4137H14.7521L12.6534 10.2905L14.3914 8.53274V10.9542C14.3914 11.7583 14.8692 12.5 16.0729 12.5C16.6442 12.5 17.1684 12.172 17.4232 11.8756L18.0403 12.4143H18.3333V8.33988H16.9607V10.4631V10.9786C16.806 11.2518 16.5907 11.4232 16.2576 11.4232C15.9199 11.4232 15.7646 11.2208 15.7646 10.5726V10.4012V8.33988L12.9547 8.33869Z",
    fill: "#FDFCEF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_7416_6287",
    x1: 9.94944,
    y1: 19.7756,
    x2: 10.0517,
    y2: -0.0494448,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9C55D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.002,
    stopColor: "#9C55D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.003,
    stopColor: "#9C55D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.111,
    stopColor: "#9753D1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.242,
    stopColor: "#884EC8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.383,
    stopColor: "#7046BA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.521,
    stopColor: "#513CA7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.672,
    stopColor: "#3C359A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.756,
    stopColor: "#2E3192"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2E3192"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7416_6287"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCtvRokuStore);
export default __webpack_public_path__ + "static/media/ctv_roku_store.a8ee7858d7dfa2b326d53d0236487caf.svg";
export { ForwardRef as ReactComponent };